import { MultiStepSignUp } from "@/components/auth/MultiStepSignUp";

export const SignUp = () => {
  return <MultiStepSignUp />;
}; 